import Socket from "./socket.service";

const socketModule = angular
  .module("app.services.socket", [])
  .service("Socket", Socket);

export default socketModule;



// WEBPACK FOOTER //
// ./src/services/socket/socket.module.js